import request from "./http";
import qs from 'qs'

//能源分项->查询用户单位所有分项
// 
export function findAllSubentry() {
    return request({
        url: "/subentry/findAllSubentry",
        method: "get",
 
    });
}


//能源分项->添加-修改分项配置
// 
export function saveEnergySubentry(params) {
    return request({
        url: "/subentry/saveSubentryConfiguration",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
 
    });
}


//能源分项->删除分项配置
// 
export function subentryDelete(params) {
    return request({
        url: "/subentry/delete/subentryConfiguration",
        method: "delete",
        params
    });
}
//能源—>通过分项id设备查询
// 
export function subentryFindDevice(params) {
    return request({
        url: "/subentry/findDevice",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
 
    });
}

//能源分项->通过分项id批量添加设备
// 
export function subentrySaveDevice(params) {
    return request({
        url: "/subentry/saveDevice",
        method: "post",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
 
    });
}
//能源分项>通过分项id量批删除设备
// 
export function subentryDeleteDevice(params) {
    return request({
        url: "/subentry/deleteDevice",
        method: "delete",
        params
 
    });
}


